import { getIssuesCountMapOrderedSeverity } from "@/domain/vulnerability"
import {
  DEFAULT_LONG_FORMAT,
  getDateFromSeconds,
  getDateInUserLocale
} from "@/helpers/date.helpers"
import { getLastDetectedCellData } from "@/helpers/table.helpers"
import {
  IMAGE_DRAWER_ID,
  VIRTUAL_MACHINE_DRAWER_ID
} from "@/organisms/Drawers/const"

import type { BranchResponse } from "@/api/useInventory.types"

export const getDisplayName = (displayName: string): string => {
  if (!displayName) return displayName

  const displayNameArr = displayName.split("/")
  if (displayNameArr.length <= 2) return displayName

  return displayNameArr.slice(0, 2).join("/")
}

export const getBranchTabData = (response: BranchResponse) => {
  const { data = [], metadata } = response || {}

  return {
    metadata,
    data: data.map((record, index) => {
      const { id, displayName, data: dataRecord } = record
      const { issuesSummary } = dataRecord
      const relatedImages = (dataRecord.relatedImages || []).map((image) => ({
        drawerEntityId: image.id,
        drawerId: IMAGE_DRAWER_ID,
        ...image
      }))
      const relatedImagesExist = !!dataRecord.relatedImages?.length
      const firstRelatedImageName = relatedImagesExist
        ? dataRecord.relatedImages[0].name
        : ""

      const issuesCounts = getIssuesCountMapOrderedSeverity(issuesSummary)

      const relatedVms = (dataRecord.relatedVms || []).map((vm) => ({
        drawerEntityId: vm.id,
        drawerId: VIRTUAL_MACHINE_DRAWER_ID,
        name: vm.displayName || vm.instanceId,
        ...vm
      }))
      const relatedResources = [...relatedImages, ...relatedVms]

      return {
        key: id,
        displayName: getDisplayName(displayName),
        ...dataRecord,
        relatedResources: {
          id: `relatedResources-${index}`,
          items: relatedResources,
          count: relatedResources.length - 1,
          label: relatedResources?.[0]?.name || "",
          copyable: true,
          width: "100%"
        },
        queryParamsRelatedImagesExternalLink: new URLSearchParams({
          repositoryNameStrict: dataRecord.repositoryName
        }).toString(),
        commitHashShort: dataRecord.commitHash?.slice(0, 7),
        firstRelatedImage: firstRelatedImageName,
        lastCveScan: dataRecord.lastCveScan
          ? getDateInUserLocale(
              getDateFromSeconds(dataRecord.lastCveScan),
              DEFAULT_LONG_FORMAT
            )
          : "",
        severity: issuesCounts,
        ...getLastDetectedCellData(record)
      }
    })
  }
}
